<template>
  <b-form @submit.prevent="submitActionCode()">
    <label>{{ $t("discountCode") }}</label>
    <b-input-group class="mb-0">
      <b-form-input
        id="actionCode"
        v-model="actionCode"
        :disabled="selected"
        type="text"
        required
      ></b-form-input>

      <b-input-group-append v-if="selected">
        <b-button variant="danger" @click="removeActionCode()"
          ><i class="fas fa-trash-alt"></i
        ></b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>

<script>
import {applyActionCode, removeActionCode} from "../../services/cart";
import {
  BForm,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BButton,
} from "bootstrap-vue";

export default {
  name: "CartActionCode",
  components: {
    BForm,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BButton,
  },
  data() {
    return {
      actionCode: "",
      selected: false,
    };
  },
  computed: {
    existingActionCode: function () {
      return this.$store.getters.actionCode;
    },
  },
  created() {
    if (this.existingActionCode !== null) {
      this.actionCode = this.existingActionCode;
      this.selected = true;
    }
  },
  methods: {
    submitActionCode: async function () {
      const result = await applyActionCode({actionCode: this.actionCode});

      if (result.success) {
        this.selected = true;
      }

      this.$toasted.show(result.message);
    },
    removeActionCode: async function () {
      const result = await removeActionCode({actionCode: this.actionCode});

      if (result.success) {
        this.selected = false;
        this.actionCode = "";
      }

      this.$toasted.show(result.message);
    },
  },
};
</script>

<style></style>
